// i18n/detector.ts
import { logger } from '@myorg/type-lib';

export const getBrowserLanguage = (): string => {
  const navLang = navigator.language || (navigator as any).userLanguage || 'en';

  // 1. Check for exact matches (e.g., "zh-TW", "ja-JP")
  const supportedFullLocales = ['zh-TW', 'zh-CN', 'ja-JP', 'en'];
  if (supportedFullLocales.includes(navLang)) return navLang;

  // 2. Handle regional variations for Chinese
  if (navLang.startsWith('zh')) {
    // Usually zh-HK, zh-MO, zh-TW use Traditional
    const traditional = ['zh-TW', 'zh-HK', 'zh-MO'];
    return traditional.some(prefix => navLang.startsWith(prefix)) ? 'zh-TW' : 'zh-CN';
  }

  // 3. Fallback to short codes
  const shortLang = navLang.split('-')[0];
  const shortToFullMap: Record<string, string> = {
    'en': 'en',
    'ja': 'ja-JP',
  };

  return shortToFullMap[shortLang] || 'en';
};

logger.log({
  actualNavigator: navigator.language,
  detectedAppLang: getBrowserLanguage()
});
